import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

import queryString from 'query-string'

import { 
	getInviteData, 
	getReferrer,
	loginUser, 
	joinAccount, 
	getNotificationData,
	doActivate,
	doUnsubscribe
} from 'state/actions'

import { getCurrentUser } from 'state/selectors/userSelectors'

class DoEmailAction extends Component{
	UNSAFE_componentWillMount = _ => {
		const {
			location,
			getInviteData,
			getReferrer,
			history,
			getNotificationData,
			doActivate,
			doUnsubscribe
		} = this.props

		const thisQueryString = location.search
		const queries = queryString.parse(thisQueryString)

		if(queries.campaign){
			window.campaign = queries.campaign
		}

		if(queries.invite){
			const inviteId = parseInt(queries.invite)

			getInviteData(inviteId, inviteData => {
				this.handleCallback(inviteData.recipient, 'invitation', null, inviteData)
			})
		}else if(queries.notification){
			const notificationId = parseInt(queries.notification)

			getNotificationData(notificationId, notificationData => {
				if(notificationData){
					this.handleCallback(notificationData.recipient, 'notification', notificationData.account_id)
				}else{
					this.handleCallback(null, 'notification')
				}
			})
		}else if(queries.activate){
			const activateKey = queries.activate

			doActivate(activateKey, _ => {
				this.handleCallback(true, 'activation')
			})
		}else if(queries.referrer){
			const referrerEmail = queries.referrer

			getReferrer(referrerEmail, 'referral', referrer => {
				this.handleCallback(false, referrer.is_affiliate ? 'affiliate' : 'referral')
			})
		}else if(queries.unsubscribe){
			const unsubType = queries.type
			const userId = queries.unsubscribe

			doUnsubscribe({ type: unsubType, id: userId }, _ => {
				this.handleCallback(true, 'unsubscribe')
			})
		}else{
			history.push('/auth/login')
		}
	}

	handleCallback = (hasRecipient, type, accountId = null, inviteData) => {
		const {
			userData,
			userId,
			allAccounts,
			inviter,
			history
		} = this.props

		let isUserLoggedIn = (userData && userData.last_open_account_id)

		if(isUserLoggedIn && !allAccounts){
			//alert('User is logged in, but there are no accounts');
		}

		if(userId && inviter){
			const isInviteForThisUser = userData.email === inviteData.recipient_email

			let lastSlug = ''

			if(isInviteForThisUser){
				if(inviteData.current_slug){
					lastSlug = inviteData.current_slug
				}else if(inviteData.account_slug){
					lastSlug = inviteData.account_slug
				}else{
					lastSlug = inviter.lastOpenAccountSlug
				}
			}

			history.push('/' + lastSlug)
		}else if(type === 'notification' && allAccounts && allAccounts[accountId]){
			const account = allAccounts[accountId]

			history.push('/' + account.slug)
		}else if(hasRecipient){
			history.push('/auth/login')
		}else{
			history.push('/auth/register')
		}
	}

	render(){
		return(
			<div></div>
		)
	}
}

const mapStateToProps = state => {
	return {
		userData: getCurrentUser(state),
		allAccounts: state.account.entities ? state.account.entities.accounts : null,
		inviter: state.auth.pendingInvitation ? state.auth.pendingInvitation.inviter : null,
		userId: state.auth.userId,
	};
}

export default withRouter(connect(mapStateToProps, {
	getInviteData, 
	getReferrer,
	loginUser,
	joinAccount, 
	getNotificationData,
	doActivate,
	doUnsubscribe
})(DoEmailAction))
